module.exports = __webpack_public_path__ + "static/img/arrow-forward-outline.83a8968b.svg";